import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqs: FAQItem[] = [
  {
    question: '黑料中文网的内容从哪里来？',
    answer: '我们的内容来源于多个渠道：一线娱乐圈记者的独家采访、业内人士的匿名爆料、公开资料的深度挖掘整理，以及用户投稿。所有内容在发布前都会经过编辑团队的核实和筛选，确保信息的可靠性和独家性。',
  },
  {
    question: '平台上的爆料内容是否真实可靠？',
    answer: '我们致力于提供真实可靠的娱乐资讯。每条爆料在发布前都会经过多重核实：包括与多个信息源交叉验证、联系当事人或相关方求证、以及参考公开的权威信息。对于暂时无法完全证实的信息，我们会明确标注"据传"或"有待核实"等提示。',
  },
  {
    question: '如何向黑料中文网投稿或爆料？',
    answer: '我们欢迎读者和业内人士提供有价值的爆料线索。您可以通过网站底部的联系方式、官方社交媒体账号或邮箱与我们取得联系。我们郑重承诺对所有爆料人信息严格保密，并在核实后给予爆料人相应的奖励。',
  },
  {
    question: '黑料中文网会侵犯明星的隐私权吗？',
    answer: '我们严格遵守法律法规和新闻伦理。我们的报道聚焦于娱乐行业的公共事务、商业行为和职业道德问题，属于正常的新闻监督范畴。对于明星的纯个人隐私（如家庭成员信息、住址等非公共信息），我们不会进行报道。',
  },
  {
    question: '网站多久更新一次内容？',
    answer: '黑料中文网保持每日更新。我们的编辑团队7×24小时关注娱乐圈动态，确保第一时间为读者提供最新的爆料资讯。正常工作日每日更新8-15篇，周末和节假日也保持每日3-5篇的更新频率。',
  },
  {
    question: '如果发现不实信息怎么办？',
    answer: '我们设有完善的纠错机制。如果您发现任何不实或有争议的信息，可以通过网站的联系方式向我们反馈。我们会在收到反馈后的24小时内启动核实程序，确认后立即进行更正或删除，并发布更正声明。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>
      <section className="py-10 md:py-14 bg-background-100">
        <div className="w-full px-4 md:px-6 max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900 mb-3">
              常见问题
            </h2>
            <p className="text-sm text-foreground-500">
              关于黑料中文网，你可能想知道的事情
            </p>
          </div>

          <div className="flex flex-col gap-3">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
                >
                  <span className="text-sm md:text-base font-medium text-foreground-800 pr-4">
                    {faq.question}
                  </span>
                  <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full transition-all duration-300 ${
                    openIndex === index ? 'bg-primary-100 text-primary-600 rotate-45' : 'bg-background-200 text-foreground-400'
                  }`}>
                    <i className="ri-add-line text-sm"></i>
                  </div>
                </button>
                <div
                  className={`transition-all duration-300 overflow-hidden ${
                    openIndex === index ? 'max-h-96 pb-5 px-5' : 'max-h-0'
                  }`}
                >
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}